import { Link } from "react-router-dom";
import "./FrequentlyServices.scss";
import Goodsandservicesgroup from "assets/images/Dashboard-icons/Goodsandservicesgroup.svg";
import Goodsandservices from "assets/images/Dashboard-icons/Goodsandservices.svg";
import Warehouse from "assets/images/Dashboard-icons/Warehouse.svg";
import measurementunit from "assets/images/Dashboard-icons/measurementunit.svg";
import WarehouseEntryDocument from "assets/images/Dashboard-icons/WarehouseEntryDocument.svg";
import Warehouseexitdocument from "assets/images/Dashboard-icons/Warehouseexitdocument.svg";

const Services = [
  {
    id: 0,
    name: "واحد سنجش",
    route: "/warehouse/measurement-unit",
    image: measurementunit,
  },
  {
    id: 1,
    name: "گروه کالا و خدمات",
    route: "/warehouse/commodity-and-services-group",
    image: Goodsandservicesgroup,
  },
  {
    id: 2,
    name: "تعریف کالا و خدمات",
    route: "/warehouse/create-commodity-and-services",
    image: Goodsandservices,
  },
  {
    id: 3,
    name: "تعریف انبار",
    route: "/warehouse/create-warehouse",
    image: Warehouse,
  },
  {
    id: 4,
    name: "سند ورود انبار",
    route: "/warehouse/create-warehouse-document/entry",
    image: WarehouseEntryDocument,
  },
  {
    id: 5,
    name: "سند خروج انبار",
    route: "/warehouse/create-warehouse-document/exit",
    image: Warehouseexitdocument,
  },
];

const FrequentlyServices = () => {
  return (
    <div className="customized-container">
      <div className="customized-wrapper">
        <div className="services-container">
          {Services.map((service) => {
            return (
              <Link to={service.route} key={service.id}>
                <div className="service-container">
                  <img src={service.image} alt="service-logo" />
                  <p>{service.name}</p>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default FrequentlyServices;
